<template>

  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Bakım Yap ({{ Binaadi }})</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" :disabled="lo" @click="SaveQr()" v-if="QrDurum">Kaydet</el-button>
        <el-button size="small" type="default" :disabled="lo" @click="Camera()">Qr Okut</el-button>
      </div>
    </div>

    <div class="SayfaIcerik" v-loading="lo">
      <el-row>

        <el-col :sm="24" :md="12" class="pr-10" style="text-align: center; align-items: center" v-if="QrDurum==false">
          <div class="camera">
            <qrcode-stream @decode="onDecode" v-if="camera==true"></qrcode-stream>
            <el-button size="mini" class="btn-success" v-if="camera==false" @click="Camera()">Qr Okut</el-button>
          </div>
        </el-col>

        <el-col :sm="24" :md="6" class="pr-10" v-if="QrDurum">
          <table class="table table-sm bilgi-table">
            <thead>
            <tr>
              <th>Bina Bilgi</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <small class="d-block">Adı</small>
                {{ Bina.adi }}
              </td>
            </tr>
            <tr>
              <td>
                <small class="d-block">Adres</small>
                {{ Bina.adres }}
              </td>
            </tr>
            <tr>
              <td>

                <el-select v-model="Form.Bakim_id" filterable placeholder="Bakım Seçiniz">
                  <el-option
                      v-for="item in Bakimlar"
                      :key="item.id"
                      :label="item.adi"
                      :value="item.id">
                  </el-option>
                </el-select>

              </td>
            </tr>
            </tbody>
          </table>
        </el-col>

        <el-col :sm="24" :md="18" v-if="QrDurum">

          <table class="table table-hover mb-4">
            <thead class="bg-gray-300">
            <tr>
              <th>#</th>
              <th>Ürun</th>
              <th>Miktar</th>
              <th>Fiyat</th>
              <th>
                <el-button class="btn-primary" size="mini" type="button" @click="addInput">Satır Ekle</el-button>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(input, key) in Form.Urun" :key="input.id">
              <td>{{ input.id }}</td>
              <td>
                <el-select v-model="input.info" value-key="id" @change="bilgi(key)">
                  <el-option
                      v-for="item in Urunler"
                      :key="item.id"
                      :label="item.adi"
                      :value="{id:item.id,money:item.sfiyat}"></el-option>
                </el-select>
              </td>
              <td>
                <el-input type="text" maxlength="12" show-word-limit v-model.number="input.miktar"></el-input>
              </td>
              <td>
                <el-input type="text" :precision="2" :step="0.1" show-word-limit
                          v-model="input.fiyat"></el-input>
              </td>
              <td>
                <el-button class="btn-primary" size="mini" type="button" @click="Sil(key)" v-if="key!=0">Satır Sil
                </el-button>
              </td>
            </tr>

            </tbody>
          </table>

        </el-col>

      </el-row>
    </div>


  </div>
</template>

<script>
export default {
  props: ['Durum'],
  data() {
    return {
      QrDurum: false,
      ModalBaslik: '',
      lo: false,
      Form: {
        Asansor_id: null,
        Bina_id: null,
        Bakimlar_id: null,
        Bakim_id: null,
        Urun: [{
          id: '1',
          Urun_id: '',
          miktar: 1,
          fiyat: '0',
        }],
        kordinat: null,

      },
      Bakimlar: null,
      camera: false,
      Urunler: null,
      Binaadi: 'Qr Kod Okutunuz',
      counter: 1,
      Bina: {
        adi: null,
        adres: null,
      },
    }
  },
  methods: {
    addInput() {
      this.Form.Urun.push({
        id: `${++this.counter}`,
        Urun_id: '',
        miktar: '1',
        fiyat: '0',
      });
    },
    Kapat() {
      this.$emit('Durum')
      this.camera = false
      this.FormDurum = false

    },
    Sil(index) {
      this.$delete(this.Form.Urun, index);
    },
    SaveQr() {


      this.$getLocation()
          .then(coordinates => {
            console.log(coordinates);
            this.Form.kordinat = coordinates;
          });

      if (this.Form.Bina_id && this.Form.Bakim_id) {
        this.lo = true

        this.$store.dispatch('Post', {...this.Form, path: 'barcode'})
            .then(response => {
              if (response.Durum == "OK") {
                this.$notify.success({
                  title: response.Mesaj,
                  customClass: 'success'
                });
                this.Binaadi = 'Qr Kod Okutunuz';
                this.Form.Asansor_id = null;
                this.Form.Bina_id = null;
                this.Form.Bakimlar_id = null;
                this.Form.Bakim_id = null;
                this.lo = false
                this.QrDurum = false
              } else {
                this.$notify.error({
                  title: response.Mesaj,
                  customClass: 'error'
                });
                this.lo = false
              }
            })
      } else {
        this.$notify.error({
          title: "Lütfen bilgileri doldurunuz.",
          customClass: 'error'
        });
      }

    },

    onDecode(decodedString) {
      if (decodedString) {
        this.camera = false
        this.$store.dispatch("Get", {path: 'barcode/' + decodedString})
            .then(response => {

              this.$notify.success({
                title: response.Mesaj,
                customClass: 'success'
              });


              this.QrDurum = response.QrDurum;
              if (response.QrDurum == true) {
                this.Form.Bina_id = response.Data.Bina.id
                this.Form.Bakimlar_id = response.Data.Bakimlar_id
                this.Form.Asansor_id = response.Data.id
                this.Bina = response.Data.Bina
                this.Binaadi = response.Data.Bina.adi + ' Binası - ' + decodedString + ' Nolu Asansör Bakımı'
                this.FormDurum = true
                this.FormButon = false
                this.CameraButon = false
              } else {

              }


              console.log(response)

            })
      }
    },

    Camera() {
      this.camera = true
      this.CameraButon = true
      this.QrDurum = false
    },

    bilgi(key) {
      console.log(key);
      this.Form.Urun[key].Urun_id = (this.Form.Urun[key].info.id)
      this.Form.Urun[key].fiyat = (this.Form.Urun[key].info.money.replace(',', '.'))
    },

    UrunListele() {
      this.$store.dispatch("Get", {path: "urun"})
          .then(response => {
            if (response.Durum == 'OK') {
              this.Urunler = response.Data;
            }
          });
    },


  },
  created() {
    this.FormDurum = false
    this.ModalBaslik = 'Asansör Bakımı Yap'
    this.$store.dispatch("Get", {path: 'care'})
        .then(response => {
          this.Bakimlar = response.Data
        })
    this.UrunListele();

  },
  watch: {
    Durum: function () {
      this.camera = this.Durum
    }
  }
}
</script>

<style scoped>
.camera {
  align-items: center;
  text-align: center;
  border: 1px solid #d1d1d1;
  display: flex;
  height: auto;
  min-height: 170px;
}

.camera button {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/qr.vue